<template>
  <div class="application-content">
    <div class="header-container">
      <span class="title">{{ $t(`${i18nPrefix}.containerTitle.applications`) }}</span>
      <div class="button-container">
        <span class="add-button iconfont iconAdd" @click="handelAddApplication"></span>
        <span v-show="showApplicationStatusList" class="list-type-btn iconfont iconliebiaomoshibeifen" @click="handleListTypeBtnClick"></span>
        <span v-show="showCandidateList" class="list-type-btn iconfont iconliebiao" @click="handleListTypeBtnClick"></span>
        <SwitchButton
          class="switch-button"
          v-model="applicationType"
          :leftLabel="$t(`${i18nPrefix}.btn.my`)"
          leftLabelValue="my"
          :rightLabel="$t(`${i18nPrefix}.btn.all`)"
          rightLabelValue="all"
          @change="handelChangeFilter"
        />
      </div>
    </div>
    <div class="operate-container">
      <el-select class="operate company-select" :placeholder="$t(`${i18nPrefix}.label.selectCompany`)" filterable v-model="selectCompany" @change="handelChangeFilter">
        <el-option
          v-for="item in companyList"
          :key="item.id"
          :label="item.i18nName"
          :value="item.id"
          :style="{'padding-left':item.level*15+'px'}"
        ></el-option>
      </el-select>
      <el-date-picker
        class="operate time-select"
        v-model="selectTime"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="-"
        format="yyyy/MM/dd"
        start-placeholder="Start Date"
        end-placeholder="End Date"
        :clearable="false"
        :picker-options="pickerOptions"
          @change="handelChangeFilter">
      </el-date-picker>
    </div>
    <div class="body-container" :class="[showCandidateList && 'show-application-list']">
      <div v-show="showApplicationStatusList" class="application-status-list">
        <ApplicationStatusContainer
          v-for="(dataType, key) in DATA_TYPE"
          class="status-item"
          :key="key"
          :dataType="dataType.type"
          :showMyJobData="showMyJobData"
          :timeRange="selectTime"
          :isLoading="loading"
          :groupInfo="groupInfo"
          :statusKey="dataType.key"
          :applicationData="applicationData[dataType.key]"
          :companyId="selectCompany"
        />
      </div>
      <CandidateList
        v-show="showCandidateList"
        hiddenSelect
        hiddenLastWorkJobName
        :isSortable="false"
        :isScrollable="false"
        :data="candidateList"
        :tableColumnWidthMap="tableColumnWidthMap"
        :cancelSelectedCandidateList="[]"
        :showAiInterviewFit="isCoachCompany"
        :showAIInterviewScore="hasAIInterviewPermission"
        @openDetail="handleOpenDetail"
        @openDuplicateCandidateDetail="openDuplicateCandidateDetail"
      />
    </div>
    <RectLoading class="loading" v-show="loading"/>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { getConstantI18nValue, getI18nPropertyValue } from '@/i18n/index'
import { DEGREE } from '@/constant/meta'
import ApplicationStatusContainer from './applicationStatusContainer.vue'
import RectLoading from '@/components/loading/rectLoading.vue'
import SwitchButton from './switchButton.vue'
import CandidateList from '@/views/adminNew/applicantList/filterList/candidateList.vue'

const DATA_TYPE = {
  ALL: {
    type: 'ALL',
    key: 'total'
  },
  NEW: {
    type: 'UNREAD',
    key: 'unRead'
  },
  SCREENING: {
    type: 'SCREENING',
    key: 'screen'
  },
  INTERVIEWING: {
    type: 'INTERVIEWING',
    key: 'interview'
  },
  ONBOARDING: {
    type: 'ONBOARDING',
    key: 'hired'
  },
  LEADS: {
    type: 'LEADS',
    key: 'leads'
  }
}

export default {
  components: {
    ApplicationStatusContainer,
    RectLoading,
    SwitchButton,
    CandidateList
  },
  data () {
    return {
      i18nPrefix: 'admin.hrDashboard',
      DATA_TYPE,
      applicationType: 'my',
      selectCompany: '',
      companyList: [],
      selectTime: [
        moment().subtract(7, 'days'),
        moment()
      ],
      groupInfo: [],
      applicationData: {
        total: {
          count: 0,
          timeData: {}
        },
        unRead: {
          count: 0,
          timeData: {}
        },
        screen: {
          count: 0,
          timeData: {}
        },
        interview: {
          count: 0,
          timeData: {}
        },
        offer: {
          count: 0,
          timeData: {}
        },
        hired: {
          count: 0,
          timeData: {}
        },
        leads: {
          count: 0,
          timeData: {}
        }
      },
      loading: false,
      applicationOriginData: [],
      unReadData: [],
      leadsData: [],
      listType: 'status',
      candidateList: [],
      pagination: {
        page: 1,
        pageSize: 20
      },
      tableColumnWidthMap: {
        candidate: 140,
        job: 115,
        workCompanyName: 115,
        maxDegree: 100,
        ageAndGender: 75,
        applyTime: 115,
        statusName: 100,
        channel: 90
      }
    }
  },
  computed: {
    showMyJobData () {
      return this.applicationType === 'my'
    },
    showApplicationStatusList () {
      return this.listType === 'status'
    },
    showCandidateList () {
      return this.listType === 'list'
    },
    pickerOptions () {
      return {
        shortcuts: [{
          text: this.$t(`${this.i18nPrefix}.btn.timeRange.DAY_7`),
          onClick (picker) {
            picker.$emit('pick', [moment().subtract(7, 'days'), moment()])
          }
        }, {
          text: this.$t(`${this.i18nPrefix}.btn.timeRange.DAY_30`),
          onClick (picker) {
            picker.$emit('pick', [moment().subtract(30, 'days'), moment()])
          }
        }, {
          text: this.$t(`${this.i18nPrefix}.btn.timeRange.DAY_180`),
          onClick (picker) {
            picker.$emit('pick', [moment().subtract(180, 'days'), moment()])
          }
        }]
      }
    },
    statusMapping () {
      const statusMapping = {}
      _.forEach(this.groupInfo, (group) => {
        _.forEach(group.status_list, (status) => {
          statusMapping[status.key] = _.lowerCase(group.name)
        })
      })
      return statusMapping
    },
    hasAIInterviewPermission () {
      return this.hasAnyPermission('PREMIUM_AI_INTERVIEW')
    },
    hasAIResumeMatchPermission () {
      return this.hasAnyPermission(['PREMIUM_AI_RESUME_MATCH', 'PERM_HR_VIEW_AI_FIT_SCORE'])
    },
    isCoachCompany () {
      return this.hasAnyPermission('COMPUTED_COMPANY_IS_COACH')
    }
  },
  created () {
    this.initTabStatus()
    this.initCompanyList()
    this.initApplicationData()
  },
  methods: {
    ...mapActions('hrDashboard', ['getApplicationDataInfo', 'changeApplicationsTabStatus']),
    ...mapGetters('hrDashboard', ['applicationsTabStatus']),
    ...mapActions('application', ['getCompanyApplicationList']),
    initTabStatus () {
      this.applicationType = this.applicationsTabStatus()
    },
    async initCompanyList () {
      this.companyList = await this.$parent.loadCompanyList()
    },
    async initApplicationData () {
      if (this.showCandidateList) {
        this.loadApplicationList()
      } else {
        this.loadApplicationDataInfo()
      }
    },
    async loadApplicationDataInfo () {
      this.loading = true
      try {
        const resp = await this.getApplicationDataInfo({
          company: this.selectCompany,
          start_date: moment(this.selectTime[0]).format('YYYY-MM-DD'),
          end_date: moment(this.selectTime[1]).add(1, 'days').format('YYYY-MM-DD'),
          my_job: this.applicationType === 'my' ? '1' : '0'
        })
        if (resp) {
          this.groupInfo = resp.group_info
          this.applicationOriginData = resp.application_data
          this.unReadData = resp.un_read_data
          this.leadsData = resp.leads_data
          this.calculateStatusCount()
        }
      } finally {
        this.loading = false
      }
    },
    async loadApplicationList () {
      const params = {
        apply_start_time: moment(this.selectTime[0]).format('YYYY-MM-DD'),
        apply_end_time: moment(this.selectTime[1]).add(1, 'days').format('YYYY-MM-DD'),
        job_types: this.showMyJobData ? 'MY_JOB' : null,
        company_ids: this.selectCompany
      }
      const i18nPrefix = 'admin.application.applicantList'
      this.loading = true
      try {
        const resp = await this.getCompanyApplicationList({
          ...params,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        })
        if (resp) {
          const vm = this
          _.forEach(resp.data, applicant => {
            const candidate = applicant.candidate
            candidate.age = candidate.birthday ? moment().diff(candidate.birthday, 'year') : ''
            candidate.name = applicant.is_agency_uploaded_and_hid ? this.$t(`${i18nPrefix}.label.hidedCandidateName`) : candidate.name
            const hasAIInterviewScore = applicant.ai_interview_score
            candidate.hasFit = (this.isCoachCompany && applicant.ai_interview_info && applicant.ai_interview_info.is_finished && applicant.ai_interview_info.total_score) || (this.hasAIInterviewPermission && hasAIInterviewScore) || (this.hasAIResumeMatchPermission && applicant.ai_match_info?.resume_ai_match_score)
            Object.defineProperty(candidate, 'maxDegreeI18nName', {
              configurable: true,
              enumerable: true,
              get () {
                const maxDegree = candidate.max_degree
                return getConstantI18nValue(DEGREE, maxDegree, 'meta.DEGREE')
              }
            })
            Object.defineProperty(candidate, 'candidateStatusName', {
              configurable: true,
              enumerable: true,
              get () {
                let i18nKey = null
                if (candidate.is_alumni) {
                  i18nKey = 'alumni'
                } else if (candidate.is_employee) {
                  i18nKey = 'employee'
                } else {
                  i18nKey = 'candidate'
                }
                if (!applicant.reviewed) {
                  i18nKey += 'New'
                }
                return vm.$t(`${i18nPrefix}.label.${i18nKey}`)
              }
            })
            Object.defineProperty(applicant, 'statusName', {
              configurable: true,
              enumerable: true,
              get () {
                return applicant.status.i18nName || getI18nPropertyValue(applicant.status, 'name_cn', 'name_en')
              },
              set (status) {
                applicant.status = status
              }
            })
          })
          _.forEach(resp.data, applicant => {
            applicant.selected = false
          })
          if (this.pagination.page === 1) {
            this.candidateList = resp.data
          } else {
            this.candidateList.push(...resp.data)
          }
        }
      } finally {
        this.loading = false
      }
    },
    handelAddApplication () {
      this.$router.push(`/v-admin/application/job/-1/add?back=${encodeURIComponent(this.$route.fullPath)}`)
    },
    handelChangeFilter () {
      this.initApplicationData()
      this.changeApplicationsTabStatus(this.applicationType)
    },
    cleanOldApplicationData () {
      this.applicationData = {
        total: {
          count: 0,
          timeData: {}
        },
        unRead: {
          count: 0,
          timeData: {}
        },
        screen: {
          count: 0,
          timeData: {}
        },
        interview: {
          count: 0,
          timeData: {}
        },
        offer: {
          count: 0,
          timeData: {}
        },
        hired: {
          count: 0,
          timeData: {}
        },
        leads: {
          count: 0,
          timeData: {}
        }
      }
    },
    calculateStatusCount () {
      this.cleanOldApplicationData()
      const statusMapping = this.statusMapping
      const applicationData = this.applicationData
      const totalData = applicationData.total
      _.forEach(this.applicationOriginData, (item) => {
        const dateTime = item[0]
        const status = item[1]
        const count = item[2]
        totalData.count += count
        totalData.timeData[dateTime] = (totalData.timeData[dateTime] || 0) + count
        const statusData = applicationData[statusMapping[status]]
        if (statusData) {
          statusData.count += count
          statusData.timeData[dateTime] = (statusData.timeData[dateTime] || 0) + count
        }
      })
      _.forEach(this.unReadData, (item) => {
        const dateTime = item[0]
        const count = item[1]
        const statusData = applicationData.unRead
        statusData.count += count
        statusData.timeData[dateTime] = (statusData.timeData[dateTime] || 0) + count
      })
      _.forEach(this.leadsData, (item) => {
        const dateTime = item[0]
        const count = item[1]
        const statusData = applicationData.leads
        statusData.count += count
        statusData.timeData[dateTime] = (statusData.timeData[dateTime] || 0) + count
      })
    },
    handleListTypeBtnClick () {
      this.listType = this.listType === 'list' ? 'status' : 'list'
      this.initApplicationData()
    },
    handleOpenDetail (rowData) {
      const candidateId = rowData.candidate.id
      const jobId = rowData.job.id
      rowData.reviewed = true
      const params = {
        apply_start_time: moment(this.selectTime[0]).format('YYYY-MM-DD'),
        apply_end_time: moment(this.selectTime[1]).add(1, 'days').format('YYYY-MM-DD'),
        job_types: this.showMyJobData ? 'MY_JOB' : '',
        company_id: this.selectCompany
      }
      const backUrl = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/profile?candidate_id=${candidateId}&job_id=${jobId}&list_params=${encodeURIComponent(JSON.stringify(params))}&page_from=applicant&back=${backUrl}`)
    },
    openDuplicateCandidateDetail (application) {
      const { candidateId, jobId } = application
      const backUrl = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/profile?candidate_id=${candidateId}&job_id=${jobId}&page_from=duplicate&back=${backUrl}`)
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
.application-content {
  background: #FFFFFF;
  border-radius: 6px;
  color: #303133;
  font-weight: 500;
  position: relative;
  margin-bottom: 15px;

  .header-container {
    padding: 20px 24px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 18px;
      height: 25px;
      line-height: 25px;
      font-weight: bold;
    }

    .button-container {
      display: flex;

      .add-button {
        font-size: 26px;
        color: #0096CC;
        margin-right: 24px;
      }

      .list-type-btn {
        font-size: 26px;
        margin-right: 24px;
        cursor: pointer;
      }
    }
  }
  .operate-container {
    display: flex;
    align-items: center;
    padding-left: 24px;
    padding-bottom: 20px;

    .operate {
      margin-right: 24px;
      height: 32px;
      width: 380px;

      ::v-deep .el-input {
        .el-input__inner {
          height: 32px;
          font-weight: 400;
          color: #909399;
        }
      }
    }

    ::v-deep .el-date-editor {
      .el-input__icon {
        height: unset;
      }

      .el-range-separator {
        width: auto;
        height: unset;
      }
    }

    .list-button {
      margin-right: 18px;
      font-size: 18px;

      .el-icon-s-unfold {
        cursor: pointer;
      }
    }
  }

  .body-container {
    padding: 0 38px 3px 38px;

    .application-status-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;

      .status-item {
        width: 30%;
        margin-bottom: 15px;
      }
    }

    .add {
      text-align: center;
      display: flex;
      .add-application {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 1 1 auto;
        color: #000;
        .add-icon {
          font-size: 60px;
          color: #6b6b6b;
          transition: all 0.1s linear;
        }
        .add-text {
          margin-top: 10px;
          font-size: 14px;
          transition: all 0.1s linear;
        }
      }
    }
    .add:hover {
      .add-icon {
        margin-top: 2px;
        font-size: 65px;
        color: #0296cc;
      }
      .add-text {
        font-size: 16px;
        color: #0296cc;
      }
    }
  }
  .show-application-list {
    position: relative;
    overflow: hidden;
    padding: 0;
    margin: 0 38px 3px 38px;
  }
}

#main {
  .loading {
    position: absolute;
    z-index: 1;
  }
}
</style>
